import React from "react";
import { Row, Col, Divider, Button } from "antd";
import { EditFilled } from "@ant-design/icons";



const View = ({ memberData, onEdit }) => {


    return (
        <>
            <Row gutter={24} className="mt-4">
                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="text-right">
                    <Button type="primary" onClick={onEdit} icon={<EditFilled />}>Modifiko</Button>
                </Col>
            </Row>
            <Row gutter={24} style={{ width: "100%" }} className="mt-2">
                <Divider style={{ marginTop: "0px", marginBottom: "10px" }} />
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Emri plotë:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData?.name + " " + memberData?.surname}</Col>
                    </Row>
                </Col>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Username:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData?.user?.username}</Col>
                    </Row>
                </Col>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                <Col span={24}>
                    <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Vendodhja:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData.living_place}</Col>
                    </Row>
                </Col>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                <Col span={24}>
                    <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Mobile:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData.phone}</Col>
                    </Row>
                </Col>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                <Col span={24}>
                    <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Email:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData.email}</Col>
                    </Row>
                </Col>
                <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            </Row>
        </>
    );
};

export default View;